<template>
  <Layout>
    <Home v-if="currentPage === 'home'" />
    <About v-if="currentPage === 'about'" />
    <Contact v-if="currentPage === 'contact'" />
    <Products v-if="currentPage === 'products'" />
    <ProductDetail v-if="currentPage === 'product'" />
    <News v-if="currentPage === 'news'" />
    <Downloads v-if="currentPage === 'downloads'" />
    <ArticleDetail v-if="currentPage === 'article'" :article-id="currentArticleId" />
  </Layout>
</template>

<script>
import Layout from './components/Layout.vue'
import Home from './components/Home.vue'
import About from './components/About.vue'
import Contact from './components/Contact.vue'
import Products from './components/Products.vue'
import ProductDetail from './components/ProductDetail.vue'
import News from './components/News.vue'
import Downloads from './components/Downloads.vue'
import ArticleDetail from './components/ArticleDetail.vue'

export default {
  name: 'App',
  components: {
    Layout,
    Home,
    About,
    Contact,
    Products,
    ProductDetail,
    News,
    Downloads,
    ArticleDetail
  },
  data() {
    return {
      currentPage: 'home',
      currentArticleId: null,
      currentCatId: null
    }
  },
  mounted() {
    // 从 sessionStorage 恢复页面状态
    const savedPage = sessionStorage.getItem('currentPage')
    const savedArticleId = sessionStorage.getItem('currentArticleId')
    const savedCatId = sessionStorage.getItem('currentCatId')
    if (savedPage) {
      this.currentPage = savedPage
    }
    if (savedArticleId) {
      this.currentArticleId = savedArticleId
    }
    if (savedCatId) {
      this.currentCatId = savedCatId
    }

    // 监听全局事件，用于切换页面
    window.addEventListener('switchPage', (event) => {
      this.currentPage = event.detail.page
      sessionStorage.setItem('currentPage', event.detail.page)
      if (event.detail.articleId) {
        this.currentArticleId = event.detail.articleId
        sessionStorage.setItem('currentArticleId', event.detail.articleId)
      } else {
        this.currentArticleId = null
        sessionStorage.removeItem('currentArticleId')
      }
      if (event.detail.catId) {
        this.currentCatId = event.detail.catId
        sessionStorage.setItem('currentCatId', event.detail.catId)
      } else {
        this.currentCatId = null
        sessionStorage.removeItem('currentCatId')
      }
    })
    // 监听返回事件
    window.addEventListener('goBack', (event) => {
      this.currentPage = 'news'
      this.currentArticleId = null
      // 如果有catId，保存以便News页面选中对应的tab
      if (event.detail && event.detail.catId) {
        this.currentCatId = event.detail.catId
        sessionStorage.setItem('currentCatId', event.detail.catId)
      } else {
        this.currentCatId = null
        sessionStorage.removeItem('currentCatId')
      }
      sessionStorage.setItem('currentPage', 'news')
      sessionStorage.removeItem('currentArticleId')
    })
  }
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html,
body {
  font-family: 'Noto Sans SC', 'Source Han Sans SC', 'PingFang SC', 'Microsoft YaHei', 'Helvetica Neue', Arial, sans-serif;
  color: #333;
  line-height: 1.6;
}

button,
input,
textarea,
select {
  font: inherit;
}
</style>
